module.exports = __webpack_public_path__ + "static/media/logo-sm.78e36ff7.png";